module.exports = __webpack_public_path__ + "static/media/mobily.e93481fe.jpg";